import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class AuthorizeNetService {    
    private testAPI = 'https://apitest.authorize.net/xml/v1/request.api';
    private productionAPI = 'https://api.authorize.net/xml/v1/request.api';

    constructor(private http: HttpClient) { }

    getPaymentNonce(secureData: any, test: boolean) {
        /*
        return new Promise((resolve, reject) => {
            this.api
            .postWithAuth('https://apitest.authorize.net/xml/v1/request.api', secureData, true, false)
            .then(data => resolve(data), error => reject(error));
        });35
        */
        
        return new Promise((resolve, reject) => {
            var headers = new HttpHeaders();
            headers = headers.append('Content-Type', 'application/json');

            this.http.post(test ? this.testAPI : this.productionAPI, secureData, { headers: headers })
            .subscribe(data => resolve(data), error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/authorizeNet.service.ts